module.exports = __webpack_public_path__ + "static/wallpaper3.accb270e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/wallpaper3.jpg
// module id = 443
// module chunks = 35783957827783